import { combineReducers } from "redux";
import { userReducer } from "./user/user.reducer";
import { categoriesReducer } from "./category/category.reducer";
import {cartReducer} from './cart/cart.reduce'


export const rootReducer = combineReducers({
    user:userReducer,
    categories:categoriesReducer,
    cart:cartReducer
})